import React, { useCallback, useState } from "react";
import { InputWidgetProps } from "./index";
import CheckboxGroup from "../../witadmin/CRUD/Common/CheckBoxGroup";

export function Checkbox({ value, onChange, schema }: InputWidgetProps) {
  const [checked, setChecked] = useState(value);
  const handleChange = useCallback(
    ({ event }) => {
      const newValue = event.target.checked;
      setChecked(newValue);
      onChange(newValue);
    },
    [onChange]
  );

  return (
    <>
      <div className="witadmin-bs3">
        <CheckboxGroup
          value={checked}
          onChange={handleChange}
          field={{ className: "witadmin-bs3", fieldName: `${schema?.title}` }}
        />
      </div>
    </>
  );
}
